import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {selectStore} from "../../../../../../store/selector";
import {
  fetchExamResultAction,
  fetchSetExamMarkAction,
  fetchSetExamResultAction
} from "../../../../../../store/pages/admission/actions";
import {Alert, Skeleton} from "antd";
import {ResultExamContent} from "../../ResultExamContent";
import {IconError} from "../../../../../../assets";
import {decodeBase64} from "../../../../../../utils/decodeBase64";

export const ExecutorStepThree = ({
                                    setCheckDisable,
                                    locked,
                                  }: any) => {
  const dispatch = useDispatch();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps'])
  const [searchParams] = useSearchParams();

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));

  const {admission: {examResult}} = useSelector(selectStore)

  useEffect(() => {
    // user_id
    // @ts-ignore
    dispatch(fetchExamResultAction({education_order_id}))
  }, [])

  const [obj, setObj] = useState([] as any)

  const handleInterviewSelect = (id: any, value: any, type: any) => {
    if (obj.length) {
      let check = obj.some((item: any) => item.id === id && Object.keys(item)[1] === type)
      if (check) {
        setObj((prevState: any) => [...prevState].map(item => item.id === id && Object.keys(item)[1] === type ? {
          ...item,
          [type]: value
        } : item))
      } else {
        setObj((prevState: any) => [...prevState, {id: id, [type]: value}])
      }
    } else {
      setObj((prevState: any) => [...prevState, {id: id, [type]: value}])
    }
  }


  const handleExamSelect = ({id, subject_name}: any, value: any, specialityId: any) => {
    if (obj.length) {
      let check = obj.some((item: any) => item.rating_id === id)
      if (check) {
        setObj((prevState: any) => [...prevState].map(item => item.rating_id === id ? {
          ...item,
          rating: value,
          selected_speciality_id: specialityId
        } : item))
      } else {
        setObj((prevState: any) => [...prevState, {
          education_order_id,
          rating_id: id,
          rating: value,
          selected_speciality_id: specialityId
        }])
      }
    } else {
      setObj((prevState: any) => [...prevState, {
        education_order_id,
        rating_id: id,
        rating: value,
        selected_speciality_id: specialityId
      }])
    }
  }

  const handleSubmit = (id: any, status: any) => {
    if (obj.length) {
      obj.map((item: any) => {
        if (item.id && item.interview_result) {
          dispatch(fetchSetExamResultAction(item))
        } else if (item.id && item.psychometric_result) {
          dispatch(fetchSetExamResultAction(item))
        } else if (item.rating_id) {
          dispatch(fetchSetExamMarkAction(item))
        }
      })
    }

    //@ts-ignore
    dispatch(fetchSetExamResultAction({id: id, status: String(status)}))
  }

  useEffect(() => {
    if (examResult.data) {
      //В .some здесь ещё был 28 статус, но это "отправлен на доработку", странно.
      let item = Array.isArray(examResult?.data?.educationOrder?.selectedSpecialities) && examResult?.data?.educationOrder?.selectedSpecialities.some((item: any) => (item.status === "28" || item.status === null) && item.statusValidate !== "gray")

      setCheckDisable(item)
    }
  }, [examResult.data])

  const handleSortArr = () => {
    let sortedArr = [] as any

    if (examResult.data && Array.isArray(examResult.data.educationOrder.selectedSpecialities)) {
      sortedArr = [...examResult.data.educationOrder.selectedSpecialities]

      sortedArr.sort((a: any, b: any) => a.priority > b.priority ? 1 : -1)
    }

    return sortedArr
  }

  return (
    <Skeleton loading={!examResult.data}>
      <>
        <div className="admission__content-item">

          <h3 className="admission__subtitle">{t('admissionView:stepsTitle.stepThree.title.result')}</h3>

          <Alert
            className="admission__error"
            message={t('admissionView:alert.stepThree')}
            type="warning"
            showIcon
            icon={<IconError/>}
          />
          {handleSortArr().map((item: any, index: any) => (
            <ResultExamContent
              key={item.id + `-${index}`}
              item={{...item, base_education: examResult.data.educationOrder.base_education}}
              obj={obj}
              disabled={false}

              locked={!locked}

              handleInterviewSelect={handleInterviewSelect}
              handleExamSelect={handleExamSelect}
              handleSubmit={handleSubmit}
            />
          ))}

        </div>

      </>
    </Skeleton>
  )
}